// Radio Kostaja. Placeholder episode list, ready for real audio later.
// DEV NOTE: Replace embedUrl values with real Spotify/Apple URLs when published.
export const PODCAST_SHOW = {
  slug: "radio-kostaja",
  name: "Radio Kostaja",
  tagline: "Conversations on brand, business, and being easier to choose.",
};

export const EPISODES = [
  {
    slug: "ep-01-outcomes-before-methods",
    title: "Outcomes before methods",
    number: 1,
    summary:
      "Why a sharper outcome beats a longer service list, and how Kostaja scopes a project so it feels safe to begin.",
    duration: "32 min",
    embedUrl: "",
    relatedServices: ["strategy-call", "brand-foundation-core"],
    relatedBlog: ["how-to-buy-design-work"],
  },
  {
    slug: "ep-02-the-brand-credibility-gap",
    title: "The brand credibility gap",
    number: 2,
    summary:
      "Most businesses are better than they look. We break down the five places that gap shows up first.",
    duration: "28 min",
    embedUrl: "",
    relatedServices: ["brand-audit", "brand-foundation-core"],
    relatedBlog: ["look-more-credible-without-rebranding"],
  },
  {
    slug: "ep-03-local-visibility-without-tricks",
    title: "Local visibility without tricks",
    number: 3,
    summary:
      "Practical local visibility moves you can make this month, none of which rely on gimmicks or fake reviews.",
    duration: "35 min",
    embedUrl: "",
    relatedServices: ["google-business-profile-optimization", "local-visibility-starter-kit"],
    relatedBlog: ["local-visibility-checklist"],
  },
];

export const getEpisodeBySlug = (slug) => EPISODES.find((e) => e.slug === slug);
